import React, { Component } from 'react';

import { LoginPage } from './loginPage';
import { SpinnerChargement } from '../components/Loader/SpinnerChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../specifique/immocom';

import './Identification.css';
import { Data } from '../data/Data';

/****************************************************************
 PROPS:
    onIdentification : méthode
    provenance : AAD ou undefined
****************************************************************/

export class Identification extends Component {
    constructor(props) {
        super(props);

        this.state = {
            estUtilisateurIdentifie: false,
            loading: false,
            messageEnCoursTraitement: '',
            hideMessageBarWarning: false,
            warningMessage: '',
            hideMessageBarError: false,
            errorMessage: ''
        };

        this.onIdentification();
    }

    onIdentification() {
        if (this.props.provenance === 'AAD') {
            let token = localStorage.getItem("adal.idtoken");

            if (token !== null) {
                this.setState({ loading: true });

                let onVerificationJetonAAD = Data._onVerificationJetonAAD(token);

                onVerificationJetonAAD
                    .then(responseFetch => {
                        let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                        if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                            let valeurRetour = responseFetch.reponseAPIobjet;
                            let estValide = valeurRetour[0];
                            let loginCompte = valeurRetour[1];

                            if (estValide) {
                                sessionStorage.setItem('loginCompte', loginCompte);

                                this.setState({
                                    estUtilisateurIdentifie: estValide,
                                    loading: false
                                });

                                this.props.onIdentification();
                            }
                            else {
                                this.setState({
                                    estUtilisateurIdentifie: false,
                                    loading: false,
                                    messageEnCoursTraitement: '',
                                    hideMessageBarWarning: false,
                                    warningMessage: 'Jeton non valide'
                                });
                            }
                        }
                        else {
                            let stateTemp = {};
                            stateTemp.estUtilisateurIdentifie = false;
                            stateTemp.loading = false;

                            Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                        }
                    });
            }
        }
        else {
            var jwt = Scriba.outils().getParameterByName('jwt');

            if (jwt !== null) {
                this.setState({ loading: true });

                let onVerificationJeton = Data._onVerificationJeton(jwt);

                onVerificationJeton
                    .then(responseFetch => {
                        let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                        if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                            let valeurRetour = responseFetch.reponseAPIobjet;
                            let estIdentifie = valeurRetour[0];
                            let loginCompte = valeurRetour[1];

                            if (estIdentifie) {
                                sessionStorage.setItem('loginCompte', loginCompte);

                                this.setState({
                                    estUtilisateurIdentifie: estIdentifie,
                                    loading: false
                                });

                                this.props.onIdentification();
                            }
                            else {
                                this.setState({
                                    estUtilisateurIdentifie: false,
                                    loading: false,
                                    messageEnCoursTraitement: '',
                                    hideMessageBarWarning: false,
                                    warningMessage: 'Jeton non valide'
                                });
                            }
                        }
                        else {
                            let stateTemp = {};
                            stateTemp.estUtilisateurIdentifie = false;
                            stateTemp.loading = false;

                            Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                        }
                    });
            }
            else {
                let onEstIdentifie = Data._onEstIdentifie();

                onEstIdentifie
                    .then(responseFetch => {
                        let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                        if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                            let valeurRetour = responseFetch.reponseAPIobjet;
                            let estIdentifie = valeurRetour[0];
                            let loginCompte = valeurRetour[1];

                            if (estIdentifie) {
                                sessionStorage.setItem('loginCompte', loginCompte);

                                this.setState({
                                    estUtilisateurIdentifie: estIdentifie,
                                    loading: false
                                });

                                this.props.onIdentification();
                            }
                            else {
                                this.setState({
                                    estUtilisateurIdentifie: false,
                                    loading: false,
                                    messageEnCoursTraitement: '',
                                    hideMessageBarWarning: false,
                                    warningMessage: 'Jeton non valide'
                                });
                            }
                        }
                        else {
                            let stateTemp = {};
                            stateTemp.estUtilisateurIdentifie = false;
                            stateTemp.loading = false;

                            Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                        }
                    });
            }
        }
    }

    render() {
        let contenu = <SpinnerChargement label="Connexion..." />;

        if (!this.state.estUtilisateurIdentifie & !this.state.loading) {
            contenu = <LoginPage onIdentification={() => this.onIdentification()} />;
        }

        return (<div className="containerIdentification">{contenu}</div>);
    }
}
